import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { staffApi } from '../api/api';
import { STAFF_KEYS } from '../lib/keys';
import type { RequestParams } from '@/shared/api';
import type { StaffCreatePayload, StaffUpdatePayload } from './types';

export const useStaffList = (params?: RequestParams) => {
  return useQuery({
    queryKey: STAFF_KEYS.list(params),
    queryFn: () => staffApi.getList(params),
    placeholderData: (prev) => prev,
  });
};

export const useStaffById = (id: number) => {
  return useQuery({
    queryKey: STAFF_KEYS.detail(id),
    queryFn: () => staffApi.getById(id),
    enabled: Boolean(id),
  });
};

export const useCreateStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: StaffCreatePayload) => staffApi.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: STAFF_KEYS.all });
    },
  });
};

export const useUpdateStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: StaffUpdatePayload) => staffApi.update(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: STAFF_KEYS.all });
    },
  });
};

export const useDeleteStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => staffApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: STAFF_KEYS.all });
    },
  });
};
